import { Instance, types } from 'mobx-state-tree';

export type MerchantModel = Instance<typeof Merchant>;

export const Merchant = types.model('Merchant', {
	id: types.union(types.string, types.number),
	name: types.string
});
